import { hooks } from "./hookactions"
export let SVLNewServiceStep2 = { hooks }
